// NOTE: айдишки продуктов которым разрешено редактировать логотип
export const EDITABLE_LOGO_PRODUCT_IDS = [2, 3];

export enum OFFER_TYPE_MARKING {
    Above = 4,
    FromRate = 6,
    AlwaysFromRate = 11,
    None = 0,
}
